// src/app/core/guards/launcher.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PlanService } from '@app/core/services/plan.service';

// Consommées par app-launcher.component.ts (mémorisation du dernier module)
// et custom/auth-hooks.ts (redirection post-login).
export const LAST_APP_KEY = 'mnc.lastApp';
export const KNOWN_APP_ROUTES = ['/moni', '/logistiki', '/pos', '/skedi', '/kratisi', '/pinaki', '/cms', '/entoli', '/agelii', '/arogi', '/odigi', '/pyxidi', '/kleidi'];

export const launcherGuard: CanActivateFn = async () => {
  const planService = inject(PlanService);
  const router      = inject(Router);

  // Le plan n'est pas encore chargé à l'arrivée post-login : sans cette attente,
  // un caser SOLO voyait le lanceur multi-modules au lieu de son interface.
  await planService.loadOnce();
  if (planService.isSolo()) {
    return router.createUrlTree(['/solo']);
  }

  // Volontairement AUCUNE redirection vers lastApp ici : ce guard protège la route
  // /launcher elle-même, il ne peut donc pas distinguer une arrivée post-login d'un
  // clic explicite sur le bouton « launcher ». Rediriger ici rendait le launcher
  // définitivement inaccessible dès qu'un module avait été ouvert une fois.
  // Le « après login → dernier module » est géré par getPostLoginRedirect()
  // (src/app/custom/auth-hooks.ts), au seul moment où c'est pertinent.
  return true;
};

